import React from 'react';

const ChangeLogCategoryCard = ({ category, activeTab, updateChangelogCategory }) => {
  return (
    <div
      className={`change-log-category-option ${activeTab === category.value ? 'selected' : ''} `}
      onClick={() => {
        updateChangelogCategory(category.value);
      }}>
      <div className="dot" style={{ backgroundColor: category.dotColor }}></div> <p>{category.label}</p>
    </div>
  );
};

export default ChangeLogCategoryCard;
